import React, {type FC} from 'react';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import {useGlobals, withGlobals} from '../../../../globalPropsContext';

export enum MobileFiltersAndSortButtonTextDataHook {
  FiltersAndSort = 'mobile-filters-and-sort-text',
  ActiveSort = 'mobile-filters-and-sort-active-sort-text',
  Filters = 'mobile-filters-and-sort-filters-text',
  CustomText = 'mobile-filters-and-sort-custom-text',
}

const MobileFiltersAndSortButtonTextComp: FC<IProvidedTranslationProps> = ({t}) => {
  const {hasFilters, hasActiveSortOption} = useGlobals();
  const customText = t('mobileFiltersAndSortingCustomButtonText');

  if (customText) {
    return <span data-hook={MobileFiltersAndSortButtonTextDataHook.CustomText}>{customText}</span>;
  }

  if (hasFilters && hasActiveSortOption) {
    return (
      <>
        <ConditionalRender
          by="shouldRenderMobileFiltersAndSortButtonText"
          dataHook={MobileFiltersAndSortButtonTextDataHook.FiltersAndSort}>
          {t('mobileFiltersAndSortingDefaultButtonText')}
        </ConditionalRender>
        <ConditionalRender
          by="shouldRenderMobileFiltersButtonText"
          dataHook={MobileFiltersAndSortButtonTextDataHook.Filters}>
          {t('mobileFiltersDefaultButtonText')}
        </ConditionalRender>
        <ConditionalRender
          by="shouldRenderMobileSortButtonText"
          dataHook={MobileFiltersAndSortButtonTextDataHook.ActiveSort}>
          {t('mobileSortDefaultButtonText')}
        </ConditionalRender>
      </>
    );
  }

  if (hasFilters) {
    return (
      <ConditionalRender by="galleryShowFilters" dataHook={MobileFiltersAndSortButtonTextDataHook.Filters}>
        {t('mobileFiltersDefaultButtonText')}
      </ConditionalRender>
    );
  }

  if (hasActiveSortOption) {
    return (
      <ConditionalRender by="galleryShowSort" dataHook={MobileFiltersAndSortButtonTextDataHook.ActiveSort}>
        {t('mobileSortDefaultButtonText')}
      </ConditionalRender>
    );
  }

  return null;
};

export const MobileFiltersAndSortButtonText = withGlobals(withTranslations()(MobileFiltersAndSortButtonTextComp));
